import { useEffect, useState } from 'react';
import { defaultRect, useStableRect } from '@elfsight/widget-utils';
import { HEADER_CONFIG, meta } from '../../../constants';

export function useHeaderResponsive() {
  const { alias } = meta;
  const { mobileBreakpoint } = HEADER_CONFIG[alias];
  const [isMobile, setIsMobile] = useState(false);
  const [headerContainerRect, setHeaderContainerRect] = useState(defaultRect);

  const [headerContainerRef] = useStableRect(
    headerContainerRect,
    setHeaderContainerRect
  );

  useEffect(() => {
    if (headerContainerRect.width <= mobileBreakpoint) {
      setIsMobile(true);

      return;
    }
    setIsMobile(false);
  }, [headerContainerRect.width, mobileBreakpoint]);

  return { headerContainerRef, isMobile };
}
